export const BUTTON_VARIANT = {
  Primary: 'PRIMARY',
  Secondary: 'SECONDARY',
  Tertiary: 'TERTIARY',
};
